import { usePermissionsContext } from "contexts/PermissionsContext";
import { Navigate } from "react-router-dom";

interface ProtectedRouteProps {
  children: React.ReactNode;
  allowedRoles?: ("admin" | "partner" | "analyst")[];
}

export default function ProtectedRoute({
  children,
  allowedRoles,
}: ProtectedRouteProps) {
  const { user } = usePermissionsContext();

  // if (!user) {
  //   return <Navigate to="/login" replace />;
  // }

  if (allowedRoles && user && !allowedRoles.includes(user.role)) {
    // Redireciona para a página apropriada baseada no role
    switch (user.role) {
      case "admin":
      case "partner":
        return <Navigate to="/analytics" replace />;
      case "analyst":
        return <Navigate to="/notas-de-agenda" replace />;
      default:
        return <Navigate to="/analytics" replace />;
    }
  }

  return <>{children}</>;
}



